import VIPStat from "./stats/vip_stat";
import {GrayLogUrl} from "./logUrl";
import {isDebug} from "../appConfig";

declare global {
    interface Window {
        log: VIPStat
    }
}

export interface GrayLogError {
    name?: string,
    message: string,
    stack?: string,
    isFatal?: boolean
}

const LogSource = "patient_engagement";

const getBrowserType = () => {
    const ua = navigator.userAgent.toLowerCase();
    const testUa = (regexp: RegExp) => {
        return regexp.test(ua)
    };
    const testVs = (regexp: RegExp) => {
        return (ua.match(regexp)?.toString()
            ?.replace(/[^0-9|_.]/g, "")
            ?.replace(/_/g, ".")) || "unknow"
    };

    // 获取到system、systemVs、platform、engine、engineVs、supporter、supporterVs、shell、shellVs

    // 系统
    let system = "unknow";
    if (testUa(/windows|win32|win64|wow32|wow64/g)) {
        // windows系统
        system = "windows";
    } else if (testUa(/macintosh|macintel/g)) {
        // macos系统
        system = "macos";
    } else if (testUa(/x11/g)) {
        // linux系统
        system = "linux";
    } else if (testUa(/android|adr/g)) {
        // android系统
        system = "android";
    } else if (testUa(/ios|iphone|ipad|ipod|iwatch/g)) {
        // ios系统
        system = "ios";
    }

    // 系统版本
    let systemVs = "unknow";
    if (system === "windows") {
        if (testUa(/windows nt 5.0|windows 2000/g)) {
            systemVs = "2000";
        } else if (testUa(/windows nt 5.1|windows xp/g)) {
            systemVs = "xp";
        } else if (testUa(/windows nt 5.2|windows 2003/g)) {
            systemVs = "2003";
        } else if (testUa(/windows nt 6.0|windows vista/g)) {
            systemVs = "vista";
        } else if (testUa(/windows nt 6.1|windows 7/g)) {
            systemVs = "7";
        } else if (testUa(/windows nt 6.2|windows 8/g)) {
            systemVs = "8";
        } else if (testUa(/windows nt 6.3|windows 8.1/g)) {
            systemVs = "8.1";
        } else if (testUa(/windows nt 10.0|windows 10/g)) {
            systemVs = "10";
        }
    } else if (system === "macos") {
        systemVs = testVs(/os x [\d._]+/g);
    } else if (system === "android") {
        systemVs = testVs(/android [\d._]+/g);
    } else if (system === "ios") {
        systemVs = testVs(/os [\d._]+/g);
    }

    // 平台
    let platform = "unknow";
    if (system === "windows" || system === "macos" || system === "linux") {
        // 桌面端
        platform = "desktop";
    } else if (system === "android" || system === "ios" || testUa(/mobile/g)) {
        // 移动端
        platform = "mobile";
    }

    // 内核+载体
    let engine = "unknow";
    let supporter = "unknow";
    if (testUa(/applewebkit/g)) {
        // webkit内核
        engine = "webkit";
        if (testUa(/edge/g)) {
            // edge浏览器
            supporter = "edge";
        } else if (testUa(/opr/g)) {
            // opera浏览器
            supporter = "opera";
        } else if (testUa(/chrome/g)) {
            // chrome浏览器
            supporter = "chrome";
        } else if (testUa(/safari/g)) {
            // safari浏览器
            supporter = "safari";
        }
    } else if (testUa(/gecko/g) && testUa(/firefox/g)) {
        // gecko内核
        engine = "gecko";
        // firefox浏览器
        supporter = "firefox";
    } else if (testUa(/presto/g)) {
        // presto内核
        engine = "presto";
        // opera浏览器
        supporter = "opera";
    } else if (testUa(/trident|compatible|msie/g)) {
        // trident内核
        engine = "trident";
        // iexplore浏览器
        supporter = "iexplore";
    }

    // 内核版本
    let engineVs = "unknow";
    if (engine === "webkit") {
        engineVs = testVs(/applewebkit\/[\d._]+/g);
    } else if (engine === "gecko") {
        engineVs = testVs(/gecko\/[\d._]+/g);
    } else if (engine === "presto") {
        engineVs = testVs(/presto\/[\d._]+/g);
    } else if (engine === "trident") {
        engineVs = testVs(/trident\/[\d._]+/g);
    }

    // 载体版本
    let supporterVs = "unknow";
    if (supporter === "chrome") {
        supporterVs = testVs(/chrome\/[\d._]+/g);
    } else if (supporter === "safari") {
        supporterVs = testVs(/version\/[\d._]+/g);
    } else if (supporter === "firefox") {
        supporterVs = testVs(/firefox\/[\d._]+/g);
    } else if (supporter === "opera") {
        supporterVs = testVs(/opr\/[\d._]+/g);
    } else if (supporter === "iexplore") {
        supporterVs = testVs(/(msie [\d._]+)|(rv:[\d._]+)/g);
    } else if (supporter === "edge") {
        supporterVs = testVs(/edge\/[\d._]+/g);
    }

    // 外壳+外壳版本
    let shell = "none";
    let shellVs = "unknow";
    if (testUa(/micromessenger/g)) {
        // 微信浏览器
        shell = "wechat";
        shellVs = testVs(/micromessenger\/[\d._]+/g);
    } else if (testUa(/qqbrowser/g)) {
        // QQ浏览器
        shell = "qq";
        shellVs = testVs(/qqbrowser\/[\d._]+/g);
    } else if (testUa(/ucbrowser/g)) {
        // UC浏览器
        shell = "uc";
        shellVs = testVs(/ucbrowser\/[\d._]+/g);
    } else if (testUa(/qihu 360se/g)) {
        // 360浏览器(无版本)
        shell = "360";
    } else if (testUa(/2345explorer/g)) {
        // 2345浏览器
        shell = "2345";
        shellVs = testVs(/2345explorer\/[\d._]+/g);
    } else if (testUa(/metasr/g)) {
        // 搜狗浏览器(无版本)
        shell = "sougou";
    } else if (testUa(/lbbrowser/g)) {
        // 猎豹浏览器(无版本)
        shell = "liebao";
    } else if (testUa(/maxthon/g)) {
        // 遨游浏览器
        shell = "maxthon";
        shellVs = testVs(/maxthon\/[\d._]+/g);
    }

    return Object.assign({
        engine,
        engineVs,
        platform,
        supporter,
        supporterVs,
        system,
        systemVs,
    }, shell === "none" ? {} : {
        shell,
        shellVs,
    });
}

const GrayLog = {
    initialize() {
        let browserType = getBrowserType();
        let initLog = Object.assign({}, browserType, {source: LogSource});
        window.log = new VIPStat(initLog, GrayLogUrl(), isDebug);
    },

    /**
     * @Desc
     * @Params userId: string  additionalInfo: object
     * @Return
     */
    updateCommon(userId: string) {
        window.log.updateCommon({
            userId: userId || "",
        });
    },

    /**
     * @Desc
     * @Params msg: string  pageName: string  additionalInfo: object
     * @Return
    */
    toast(msg: string, pageName?: string, additionalInfo?: object) {
        msg && window.log.toast({
            msg: msg,
            spma: pageName || "",
            ...(additionalInfo || {}),
        })
    },

    /**
     * @Desc
     * @Params pageName: string  additionalInfo: object
     * @Return
     */
    pageView(pageName: string, additionalInfo?: object) {
        pageName && window.log.pageview({
            spma: pageName,
            ...(additionalInfo || {}),
        })
    },

    /**
     * @Desc
     * @Params eventName: string  additionalInfo: object
     * @Return
     */
    event(eventName: string, additionalInfo?: object) {
        eventName && window.log.event({
            "ev_ct": eventName,
            ...(additionalInfo || {}),
        })
    },

    /**
     * @Desc
     * @Params api: string  statusCode: number  additionalInfo: object
     * @Return
     */
    network(api: string, statusCode: number, additionalInfo?: object) {
        window.log.network({
            api: api,
            statusCode: statusCode,
            ...(additionalInfo || {}),
        })
    },

    /**
     * @Desc
     * @Params err: object  additionalInfo: object
     * @Return
     */
    error(err: GrayLogError, additionalInfo?: object) {
        err && window.log.error({
            ...err,
            ...(additionalInfo || {}),
        })
    },
};

export {
    GrayLog,
}
